module.exports = __webpack_public_path__ + "static/fanduel-94caad21c7cf39c7ce653519e1849eb7.png";